import { PDFDocument, StandardFonts, rgb, PDFPage, PDFFont, PDFEmbeddedPage, grayscale } from 'pdf-lib'

import { InputElement, InputType } from '../flowengine/model/Element';

import { getPageByKey, getPageByIndex, getElementWithPagekey } from '../flowengine/FlowEngineAPI';
import { Page } from "../flowengine/model/Page"

//require("downloadjs")(data, strFileName, strMimeType);
import download from 'downloadjs'

import { uploadFilesList } from "../upload/UploadFilesList"


//
// ==============================================================================================================================
//
const BORDER_LEFT: number = 50;
const FONT_SIZE: number = 10;
//var theFont: PDFFont;


// --------------------------
export async function createPDFGeneric(): Promise<Uint8Array> {
    // Create a new PDFDocument
    const pdfDoc = await PDFDocument.create();
    
    // Embed the Times Roman font
    let theFont: PDFFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    let theFontBold: PDFFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    
    // Add a blank page to the document
    const page = pdfDoc.addPage();
    
    // Get the width and height of the page
    const { width, height } = page.getSize();
    //
    
    // Draw a string of text toward the top of the page
    //let flow = getFlow();

    //const FONT_SIZE = 15;
    let line = 8;
    page.drawText('Layout summary', {
      x: 50,
      y: height - line * FONT_SIZE,
      size: FONT_SIZE * 2,
      font: theFont,
      color: rgb(0.9453125, 0.578125, 0.0),    // rgb(0, 0.53, 0.71),  //rgb(242, 148, 0)
    });
    line++;
    
    // always print first page:
    let pageToDisplay: Page | undefined = getPageByIndex(0);
    //line = drawSinglePage(pageToDisplay, page, line);
    line = drawSinglePage(pageToDisplay, page, line, FONT_SIZE, theFont, theFontBold);

    while(pageToDisplay !== undefined) {
        let nextpagekey: string = pageToDisplay.nextResolver();
        let nextPageToDisplay: Page | undefined = getPageByKey(nextpagekey);

        if(nextPageToDisplay === undefined || nextPageToDisplay.name === pageToDisplay.name)
            break;

        pageToDisplay = nextPageToDisplay;
        line = drawSinglePage(pageToDisplay, page, line, FONT_SIZE, theFont, theFontBold);
    }


// ----------
// DIRTY: hard-coded !!! Iterate for all InputImage and insert generically !!!

    // import image for motor
    let elImage: InputElement | undefined = getElementWithPagekey("page1", "Motorauswahl");
    if((elImage !== undefined) && (elImage !== undefined)) {
        //let imageName: string = elImage.value as string;
        let imageName: string = elImage.getValue() as string;
        await insertImageJPG(pdfDoc, page, imageName, 25, 3.0);
    }

    // import image for pump
    elImage = getElementWithPagekey("page8a", "Pumpentyp");
    if((elImage !== undefined) && (elImage !== undefined)) {
        //let imageName: string = elImage.value as string;
        let imageName: string = elImage.getValue() as string;
        await insertImageJPG(pdfDoc, page, imageName, 50, 3.0);
    }

    // 
    // import image for FLE-PA
    elImage = getElementWithPagekey("page1", "FlywheelSize");
    if((elImage !== undefined) && (elImage !== undefined)) {
        //let imageName: string = elImage.value as string;
        let imageName: string = elImage.getValue() as string;
        await insertImageJPG(pdfDoc, page, imageName, 20, 3.0);
    }

    // import image for FLE-PA
    elImage = getElementWithPagekey("page1", "FlywheelSize");
    if((elImage !== undefined) && (elImage !== undefined)) {
        let imageName: string = "DimFlange";
        await insertImageJPG(pdfDoc, page, imageName, 30, 2.0);
    }

    // import image for FLE-PA
    elImage = getElementWithPagekey("page1", "FlywheelSize");
    if((elImage !== undefined) && (elImage !== undefined)) {
        let imageName: string = "DimHousing";
        await insertImageJPG(pdfDoc, page, imageName, 40, 2.0);
    }

    // import image for FLE-PA
    elImage = getElementWithPagekey("page1", "FlywheelSize");
    if((elImage !== undefined) && (elImage !== undefined)) {
        let imageName: string = "FLE-PA-sketch";
        await insertImageJPG(pdfDoc, page, imageName, 75, 1.1);
    }

    // ------------------------
    // insert logo:
    await insertImageKTRLogo(pdfDoc, page);

    // add pdfs from file upload area:
    for(let idx: number = 0; idx<uploadFilesList.length; idx++) {
        let filetype: string = uploadFilesList[idx].type.toLowerCase();
        if(filetype.includes("jpg") || filetype.includes("jpeg")) {
            await insertPageWithImageAsBytesJPG(pdfDoc, uploadFilesList[idx].name, uploadFilesList[idx].size, uploadFilesList[idx].type, uploadFilesList[idx].content);
        }
        else if(filetype.includes("png")) {
            await insertPageWithImageAsBytesPNG(pdfDoc, uploadFilesList[idx].name, uploadFilesList[idx].size, uploadFilesList[idx].type, uploadFilesList[idx].content);
        }
        else if(filetype.includes("pdf")) {
            await embedPDFFile(pdfDoc, uploadFilesList[idx].name, uploadFilesList[idx].size, uploadFilesList[idx].type, uploadFilesList[idx].content);
        }
        else if(filetype.includes("text")) {
            await insertPageWithTextAsBytes(pdfDoc, uploadFilesList[idx].name, uploadFilesList[idx].size, uploadFilesList[idx].type, uploadFilesList[idx].content, theFont);
        }
        else {
            console.log("Cannot embed file <" + uploadFilesList[idx].name + "> with Mime-Type <" + uploadFilesList[idx].type + "> for scurity reasons. Only JPG, PNG and PDF allowed !");
        }

        //await addAttachment(pdfDoc, uploadFilesList[idx].name, uploadFilesList[idx].size, uploadFilesList[idx].type, uploadFilesList[idx].content);
    }

    /*
    uploadFilesList.forEach(element => {
        if((element.size !== 0) && (element.content !== null) && (element.content !== undefined)) {
            if(element.type === "application/pdf")
                embedPDFFile(pdfDoc, element.name, element.size, element.type, element.content);
            //else if(element.type === "text/...")
            //    appendPDFFile(pdfDoc, element.name, element.size, element.type, element.content);
        }
    });
    */

    // current date
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    var datestring = mm + '/' + dd + '/' + yyyy;        
    page.drawText(datestring, {
        x: width * 0.9,
        y: FONT_SIZE * 7,
        size: FONT_SIZE * 0.5,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),
    });

    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes: Uint8Array = await pdfDoc.save();

    return pdfBytes;

    // Trigger the browser to download the PDF document
    //download(pdfBytes, "ic-engine-layout.pdf", "application/pdf");
}

export async function downloadPDFGeneric(fname: string | undefined) {
    if(fname === undefined)
        fname = "layout-overview";

    fname = fname + ".pdf"    
    let pdfBytes: Uint8Array = await createPDFGeneric();
    download(pdfBytes, fname, "application/pdf");
}

export async function insertImageKTRLogo (pdfDoc: PDFDocument, page: PDFPage) {
    const pngUrl = process.env.PUBLIC_URL + '/KTRMadeForMotionBitmap.PNG';
    const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());
    const pngImage = await pdfDoc.embedPng(pngImageBytes)
    const pngDims = pngImage.scale(0.5);

    const x: number = page.getWidth() - (pngDims.width * 1.1);
    const y: number = page.getHeight() - (pngDims.height * 1.1);

    page.drawImage(pngImage, {
        x: x,
        y: y,
        width: pngDims.width,
        height: pngDims.height,
    })


    /*
    page.drawImage(pngImage, {
        x: page.getWidth() - (pngDims.width * 1.1),
        y: page.getHeight() - (pngDims.height * 1.1),
        width: pngDims.width,
        height: pngDims.height,
    })
    */
};

export async function insertPageWithImageAsBytesJPG(pdfDoc: PDFDocument, name: string, size: number, type: string, content: string | ArrayBuffer | null) {
    if(content instanceof ArrayBuffer) {
        try {
            const jpgImage = await pdfDoc.embedJpg(content)

            // create new page:
            const page = pdfDoc.addPage();

            let widthDivider: number = 1.0;  // pass as parameter ?
            let line: number = 80;  // pass as parameter ?

            let targetWidth = (page.getWidth() / widthDivider);
            let scale = targetWidth / jpgImage.width;
        
            const jpgDims = jpgImage.scale(scale);
            page.drawImage(jpgImage, {
                //x: page.getWidth() / 2 - jpgDims.width / 2,
                //y: page.getHeight() / 2 - jpgDims.height / 2,
                x: page.getWidth() - (jpgDims.width * 1.05),
                //y: page.getHeight() - jpgDims.height,
                y: page.getHeight() - line * FONT_SIZE,
                width: jpgDims.width,
                height: jpgDims.height,
            })
        }
        catch(e) {
            console.log("Insert JPG As Bytes: " + e);
        }
    }
}

export async function insertPageWithImageAsBytesPNG(pdfDoc: PDFDocument, name: string, size: number, type: string, content: string | ArrayBuffer | null) {
    if(content instanceof ArrayBuffer) {
        try {
            const jpgImage = await pdfDoc.embedPng(content)

            // create new page:
            const page = pdfDoc.addPage();

            let widthDivider: number = 1.0;  // pass as parameter ?
            let line: number = 80;  // pass as parameter ?

            let targetWidth = (page.getWidth() / widthDivider);
            let scale = targetWidth / jpgImage.width;
        
            const jpgDims = jpgImage.scale(scale);
            page.drawImage(jpgImage, {
                x: page.getWidth() - (jpgDims.width * 1.05),
                y: page.getHeight() - line * FONT_SIZE,
                width: jpgDims.width,
                height: jpgDims.height,
            })
        }
        catch(e) {
            console.log("Insert PNG As Bytes: " + e);
        }
    }
}


export async function insertPageWithTextAsBytes(pdfDoc: PDFDocument, name: string, size: number, type: string, content: string | ArrayBuffer | null, theFont: PDFFont) {
    if(content instanceof ArrayBuffer) {
        try {
            var binaryString: string = '',
            bytes = new Uint8Array(content),
            length = bytes.length;
            for (var i = 0; i < length; i++) {
                binaryString += String.fromCharCode(bytes[i]);
            }
    
            // create new page:
            const page = pdfDoc.addPage();
            
            const { width, height } = page.getSize();

            const fontSize = 12;
            page.drawText(binaryString, {
              x: 50,
              y: height - 1 * fontSize,
              size: fontSize,
              font: theFont,
              color: rgb(0, 0.53, 0.71),
            })
        }
        catch(e) {
            console.log("Insert PNG As Bytes: " + e);
        }
    }
}


export async function insertImageJPG (pdfDoc: PDFDocument, page: PDFPage, imageName: string, line: number, widthDivider: number = 3.0) {
    const jpgUrl = process.env.PUBLIC_URL + '/images/' + imageName.toLowerCase() + '.jpg';
    const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer());

    const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)

    // we scale image to width of 1/3:
    //let targetWidth = (page.getWidth() / 3.0);
    let targetWidth = (page.getWidth() / widthDivider);
    let scale = targetWidth / jpgImage.width;

    const jpgDims = jpgImage.scale(scale);
    page.drawImage(jpgImage, {
        //x: page.getWidth() / 2 - jpgDims.width / 2,
        //y: page.getHeight() / 2 - jpgDims.height / 2,
        x: page.getWidth() - (jpgDims.width * 1.05),
        //y: page.getHeight() - jpgDims.height,
        y: page.getHeight() - line * FONT_SIZE,
        width: jpgDims.width,
        height: jpgDims.height,
    })

};



export function drawHeader(p: Page | undefined, page: PDFPage, line: number, fontSize: number, theFontBold: PDFFont, text: string): number {
    if(p === undefined)
        return line;

    line++;

    const { width, height } = page.getSize();
    let y: number = height - line * fontSize;

    page.drawRectangle({
        x: BORDER_LEFT,
        y: y,
        width: width * 0.9,
        height: fontSize * 1.2,
        //rotate: degrees(0),
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: grayscale(0.7),    //rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });

    page.drawText(text, {
        //x: 50,
        //y: height - line * fontSize,
        x: BORDER_LEFT  + (fontSize * 0.1),
        y: y + (fontSize * 0.2),
        size: fontSize,
        font: theFontBold,
        color:  rgb(0.0, 0.0, 0.0),    // rgb(0, 0.53, 0.71),
    });

    //line++;

    return line;
}


function drawSingleLine(page: PDFPage, x1: number, x2: number, y: number, fontSize: number, theFont: PDFFont, label: string, value: string): void {
    /*
    page.drawRectangle({
        x: x2  - (fontSize * 0.1),
        y: y - (fontSize * 0.1),
        width: 100,
        height: fontSize,
        //rotate: degrees(0),
        borderWidth: 0.5,
        borderColor: rgb(0.0, 0.0, 0.0),       // grayscale(0.5),
        color: rgb(0.9453125, 0.578125, 0.0),
        opacity: 1.0,
    });
    */

    page.drawText(label, {
        x: x1,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.2, 0.2, 0.2),    // rgb(0, 0.53, 0.71),
    });
    page.drawText(value, {
        x: x2,
        y: y,
        size: fontSize * 0.8,
        font: theFont,
        color: rgb(0.0, 0.0, 0.0),    // rgb(0, 0.53, 0.71),
        //color: rgb(0.9453125, 0.578125, 0.0),    // rgb(0, 0.53, 0.71),  //rgb(242, 148, 0)
    });

}



export function drawSinglePage(p: Page | undefined, page: PDFPage, line: number, fontSize: number, theFont: PDFFont, theFontBold: PDFFont): number {
    if(p === undefined)
        return line;

    const { width, height } = page.getSize();

    const COL_LABEL_WIDTH: number = 150;
    const COL_OFFSET: number = width/2.3;

    line++;
    line = drawHeader(p, page, line, fontSize, theFontBold, p.label);

    //
    //line++;
    line++;

    let x1: number = BORDER_LEFT;
    let x2: number = BORDER_LEFT + COL_LABEL_WIDTH;
    let y: number = height - line * fontSize;

    const MAX_COL: number = 1;    // 0-based
    let col: number = 0;

    for(let i=0; i<p.elements.length; i++) {
        let e: InputElement | undefined = p.elements[i];
        if((e.type === InputType.Action) || (e.type === InputType.PageForward)  || (e.type === InputType.Image))  // we omit elements with no input value
            continue;

        if((e.isVisible !== undefined) && (e.isVisible() === false))
            continue;

        //
        x1 = BORDER_LEFT + (COL_OFFSET * col);
        x2 = BORDER_LEFT + (COL_OFFSET * col) + COL_LABEL_WIDTH;
        y = height - line * fontSize;
        col++;
        if(col > MAX_COL) { 
            line++;
            col = 0;
        }
    
        //let outputValue: any = e.value;    // vorläufig für Demo
        let outputValue: any = e.getValue();    // vorläufig für Demo
        if(e.type === InputType.ValueBoolean) {
            //outputValue = (e.value === true ? "Ja" : "Nein");
            outputValue = (e.getValue() === true ? "Ja" : "Nein");
        }

        if(e.unit !== undefined && e.unit.length > 0) {
            outputValue = outputValue + " " + e.unit;
        }

        //console.log(e.label + ": " + outputValue);
        drawSingleLine(page, x1, x2, y, fontSize, theFont, e.label, " " + outputValue);
    }

    return line;
}


export async function addAttachment(pdfDoc: PDFDocument, name: string, size: number, type: string, content: string | ArrayBuffer | null) {
    if(content instanceof ArrayBuffer) {
        try {
            await pdfDoc.attach(content, name, {
              mimeType: type,
              description: 'Attachment ' + name,
              creationDate: new Date('2021/01/01'),
              modificationDate: new Date('2021/01/01'),
            })
            
            const page = pdfDoc.addPage();
            page.drawText('This PDF has two attachments', { x: 135, y: 415 })
            
            //const pdfBytes = await pdfDoc.save()
        }
        catch(e) {
            console.log("Attach file: " + e);
        }
    }

}


export async function embedPDFFile(pdfDoc: PDFDocument, name: string, size: number, type: string, content: string | ArrayBuffer | null) {
    if(content instanceof ArrayBuffer) {
        try {
            const pdfToEmbed = await PDFDocument.load(content, {ignoreEncryption: true});

            let pagesToEmbed: PDFPage[] = pdfToEmbed.getPages();

            for(let idx: number = 0; idx < pagesToEmbed.length; idx++) {
                const docToInsert = await pdfDoc.embedPage(pagesToEmbed[idx]);

                //const docToInsert: PDFPage = await pdfDoc.embedPdf(pagesToEmbed[idx]);

                const page = pdfDoc.addPage();
                const docToInsertDims = docToInsert.scale(0.5);
    
                const relationWidthToHeight = docToInsertDims.width / docToInsertDims.height;
                docToInsertDims.width = page.getWidth();  // set imported page to full width of hosting page
                docToInsertDims.height = page.getWidth() / relationWidthToHeight;   // preserve height in relation to new width
    
                page.drawPage(docToInsert, {
                        ...docToInsertDims,
                        x: page.getWidth() - docToInsertDims.width,
                        y: page.getHeight() - docToInsertDims.height,
                        //y: page.getHeight() / 2 - docToInsertDims.height / 2 - 50,
                      }            
                    );
            }
        }
        catch(e) {
            console.log("EmbedPDF" + e);
        }
    }

}
